// Push notifications client helpers
import { api } from "./api";

function urlBase64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribePush(packs = ["engagement", "social"]) {
  if (!pushSupported()) throw new Error("Push not supported in this browser");
  const reg = await navigator.serviceWorker.register("/sw.js");
  const perm = Notification.permission === "granted"
    ? "granted"
    : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");

  const { data: vapid } = await api.get("/push/vapid-public-key");
  if (!vapid.configured || !vapid.key) throw new Error("Push isn't configured on the server");

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapid.key),
  });
  const raw = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys,
    packs,
  });
  return sub;
}

export async function unsubscribePush() {
  const sub = await getSubscription();
  if (!sub) return;
  try {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  } catch (err) {
    if (process.env.NODE_ENV === "development") {
      console.error("Push unsubscribe failed:", err);
    }
  }
  await sub.unsubscribe();
}
